import ComponentLayout from "../../../../src/layouts/component-layout";
import { HeadingTags, HeadingSizes, HeadingWeights, HeadingStretch, defaultHeadingTag, HeadingLetterSpacing } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  HeadingTags,
  HeadingSizes,
  HeadingWeights,
  HeadingStretch,
  defaultHeadingTag,
  HeadingLetterSpacing,
  Container,
  PropTableValues,
  React
};